(function(){
  function init(){
    var form=document.getElementById('FGMContactForm');
    if(!form||form.dataset.pickupReady)return;
    form.dataset.pickupReady='true';
    var topic=document.getElementById('FGMContactTopic'),fields=document.getElementById('FGMPickupFields'),phone=document.getElementById('FGMContactPhone'),message=document.getElementById('FGMContactMessage'),button=form.querySelector('button[type="submit"]');
    var day=document.getElementById('FGMDay'),month=document.getElementById('FGMMonth'),year=document.getElementById('FGMYear');
    function validateDate(){
      day.setCustomValidity('');
      if(fields.disabled)return;
      var any=day.value||month.value||year.value;
      if(!any)return;
      if(!day.value||!month.value||!year.value){day.setCustomValidity('Please select a day, month and year, or leave all three blank.');return;}
      var date=new Date(Number(year.value),month.selectedIndex-1,Number(day.value)),today=new Date();today.setHours(0,0,0,0);
      if(date.getMonth()!==month.selectedIndex-1){day.setCustomValidity('Please choose a valid date.');return;}
      if(date<today)day.setCustomValidity('Please choose today or a future date.');
    }
    function update(){
      var pickup=topic.value==='Service pickup & delivery';
      fields.hidden=!pickup;fields.disabled=!pickup;
      fields.querySelectorAll('[data-pickup-required]').forEach(function(input){input.required=pickup;});
      phone.required=pickup;
      button.textContent=pickup?'Send booking request →':'Send enquiry →';
      message.labels[0].textContent=pickup?'Service needed / problem description *':'Your message';
      message.placeholder=pickup?'Describe the service or problem, plus any access details for pickup.':'Machine, part number, model or question…';
      validateDate();
    }
    if(new URLSearchParams(window.location.search).get('enquiry')==='pickup-delivery')topic.value='Service pickup & delivery';
    topic.addEventListener('change',update);
    [day,month,year].forEach(function(input){input.addEventListener('change',validateDate);});
    form.addEventListener('submit',function(event){validateDate();if(!form.checkValidity()){event.preventDefault();form.reportValidity();}});
    window.addEventListener('pageshow',update);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
